import { Component, EventEmitter, Output } from '@angular/core';
import { GlobalUtilsService } from 'src/app/global-utils.service';
import { SelectInputOption } from '../contact-form-types';

@Component({
  selector: 'app-input-select-options',
  template: `
    <div
      class="input-select-options-wrap"
      [ngClass]="{
        tablet: globalUtilsService.isTablet(),
        mobile: globalUtilsService.isMobile()
      }"
    >
      <a *ngFor="let option of options" (click)="selectOption(option)">{{
        option.label
      }}</a>
    </div>
  `,
  styles: [
    `
      :host {
        width: 100%;
      }

      .input-select-options-wrap {
        margin-top: 0px;
        background: white;
        overflow: auto;
        width: 100%;
        max-height: 250px;
        border-radius: 0.2rem;
        border: 1px solid #e0e0e0;
        box-shadow: 1px 8px 36px -9px rgba(0, 0, 0, 0.6);
      }

      .input-select-options-wrap a {
        display: block;
        font-size: 0.4rem;
        font-weight: 900;
        padding: 0.47rem;
        border-bottom: 1px solid #e0e0e0;
        line-height: 0.45rem;
        transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);
        cursor: pointer;
      }

      .input-select-options-wrap a:hover {
        color: #13A538;
        transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);
      }

      .input-select-options-wrap a:last-child {
        border-bottom: 0;
      }

      .input-select-options-wrap.tablet {
        border-radius: 0.2rem;
      }

      .input-select-options-wrap.tablet a {
        font-size: 0.76rem;
        padding: 0.8rem;
        line-height: 0.45rem;
      }

      .input-select-options-wrap.mobile {
        border-radius: 0.2rem;
      }

      .input-select-options-wrap.mobile a {
        font-size: 0.5rem;
        padding: 0.8rem;
        line-height: 0.45rem;
      }
    `
  ]
})
export class InputSelectOptionsComponent {
  options: SelectInputOption[];

  @Output()
  optionSelected: EventEmitter<string>;

  constructor(public globalUtilsService: GlobalUtilsService) {
    this.options = [];
    this.optionSelected = new EventEmitter<string>();
  }

  selectOption(value: SelectInputOption) {
    this.optionSelected.emit(value.value);
  }
}
